import { WPublishedPageModel } from "./w-published-page.model";

export class WPublishedGoodsModel {
  constructor(
    public pCode: string,
    public goodsName: string,
    public standardName: string,
    public pageNum: string,
    public pageInfo: string,
    public wPublishedPages: WPublishedPageModel[]
  ) { }
}